import { useMemo } from 'react';
import { MenuNavigationShellPage } from '@/app/layout/MenuNavigationShellPage';
import type { AgendaRegistration } from '@/app/layout/MenuNavigationShellPage';
import { legacyFormAgenda } from './legacyFormAgenda';
import { LegacyFormShellPage } from './LegacyFormShellPage';

export function LegacyFormSlicePage() {
  const agendas: AgendaRegistration[] = useMemo(
    () => [{ agenda: legacyFormAgenda, component: LegacyFormShellPage }],
    []
  );

  return <MenuNavigationShellPage agendas={agendas} rootAgenda={legacyFormAgenda} />;
}
